export const DescricaoTela = {
    prescritores: "prescritores",
    produtos: "produtos",
    fornecedores: "fornecedores",
    clientes: "clientes",
    formulasPadrao: "formulas_padrao",
};

export const AcaoController = {
    insert: "insert",
    update: "update",
    delete: "delete",
    activation: "activation",
    seniorUpdate: "seniorUpdate",
    edicaoFormulaPadrao: "HasPermissaoEdicaoFormulaPadrao",
};
